export const DOCUMENTS_ROUTER = {
  TITLE: "Documents",
  PATH: "/documents/*",
};
